export default __webpack_public_path__ + "static/media/cntr-tracking-rq-12-red.896740aa.svg";